import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  ref: "modalContent",
  class: "LoadingModal"
}
const _hoisted_2 = {
  key: 0,
  class: "LoadingActiveText"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.modalStatusLoadingIsActive)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Loading ..."))
      : (_ctx.modalStatusLoadingIsFailed)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[0] || (_cache[0] = _createElementVNode("p", null, [
              _createElementVNode("i", { class: "lnr-notification-circle FailIcon" })
            ], -1 /* CACHED */)),
            _cache[1] || (_cache[1] = _createElementVNode("p", null, "A problem occurred, please close the window and try again", -1 /* CACHED */))
          ], 64 /* STABLE_FRAGMENT */))
        : (_ctx.modalStatusLoadingIsSuccess)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _cache[2] || (_cache[2] = _createElementVNode("p", null, [
                _createElementVNode("i", { class: "lnr-checkmark-circle SuccessIcon" })
              ], -1 /* CACHED */)),
              _cache[3] || (_cache[3] = _createElementVNode("p", null, "Your changes were saved", -1 /* CACHED */))
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */))
}